import { Box, Button, Card, Form, Icon, Stack } from '@ace-clublabs/shared-component-library';
import { RoleTypeRadioLabel } from './RoleTypeRadioLabel';
import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../state/state';
import { useEffect, useState } from 'react';
import { RoleTypeRadio } from './RoleTypeRadio';
import { useHistory } from 'react-router-dom';
import { Pages } from '../../utils/constants';
import { RoleTypeDisclaimer } from './RoleTypeDisclaimer';
import { getHasReachedRoleTypeMax } from '../../state/helpers';

export const RoleTypeForm = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const [formData] = useGlobalState('formData');
  const [prospectiveCosts] = useGlobalState('prospectiveCosts');
  const history = useHistory();
  const [selectedRoleType, setRoleType] = useState(null as null | RoleType);

  const roles = memberDetails?.prospectiveMemberRules?.memberRoles;

  const benefitLevel = formData?.requestedMembershipLevel;
  // @ts-ignore
  const associateCosts = prospectiveCosts[benefitLevel?.toLowerCase()]?.memberRoles || {};

  const inRenewal = memberDetails?.inRenewal;

  const AD_role = roles?.find((role) => role.roleType === RoleType.ADULT_ASSOCIATE);
  const DE_role = roles?.find((role) => role.roleType === RoleType.DEPENDENT);
  const AS_role = roles?.find((role) => role.roleType === RoleType.ASSOCIATE);

  const canAddAssociateRoleType = AS_role?.maximumAllowed! > 0;
  const canAddDependentRoleType = DE_role?.maximumAllowed! > 0;
  const canAddAdultRoleType = AD_role?.maximumAllowed! > 0;

  const DEmaxHasBeenReached = getHasReachedRoleTypeMax(RoleType.DEPENDENT, memberDetails, formData);
  const ASmaxHasBeenReached = getHasReachedRoleTypeMax(RoleType.ASSOCIATE, memberDetails, formData);
  const ADmaxHasBeenReached = getHasReachedRoleTypeMax(RoleType.ADULT_ASSOCIATE, memberDetails, formData);

  const submitButtonDisabled = !selectedRoleType;

  const autoSelectRoleType = () => {
    if (canAddAssociateRoleType && ASmaxHasBeenReached) {
      return;
    } else if (canAddAssociateRoleType) {
      setRoleType(RoleType.ASSOCIATE);
    } else if (DEmaxHasBeenReached && !ADmaxHasBeenReached) {
      setRoleType(RoleType.ADULT_ASSOCIATE);
    } else if (ADmaxHasBeenReached && !DEmaxHasBeenReached) {
      setRoleType(RoleType.DEPENDENT);
    }
  };

  useEffect(() => {
    autoSelectRoleType();
  }, []);

  const onSubmit = () => {
    history.push(Pages.AssociateForm, { roleType: selectedRoleType });
  };

  return (
    <Form onSubmit={onSubmit} id="role-type-form" sx={{ marginTop: '0.5rem' }}>
      <Stack direction={'column'} justifyContent={'space-between'} gap={'0.5rem'} id="role-type-radio">
        {canAddAdultRoleType ? (
          <RoleTypeRadio
            role={AD_role!}
            selectedRole={selectedRoleType}
            cost={associateCosts[AD_role?.roleType!]}
            inRenewal={inRenewal!}
            selectRoleType={(roleType: RoleType) => setRoleType(roleType)}
            disabled={ADmaxHasBeenReached}
          />
        ) : (
          <></>
        )}
        {canAddDependentRoleType ? (
          <RoleTypeRadio
            role={DE_role!}
            selectedRole={selectedRoleType}
            cost={associateCosts[DE_role?.roleType!]}
            inRenewal={inRenewal!}
            selectRoleType={(roleType: RoleType) => setRoleType(roleType)}
            disabled={DEmaxHasBeenReached}
          />
        ) : (
          <></>
        )}
      </Stack>
      <Stack direction={'column'} justifyContent={'space-between'} gap={'0.5rem'} id="role-type-associate-label">
        {canAddAssociateRoleType ? (
          <Card
            sx={{
              padding: '0',
              width: '100%',
            }}
          >
            <Box sx={{ padding: '1rem' }}>
              <RoleTypeRadioLabel
                checked
                roleType={AS_role?.roleType!}
                limitPerHousehold={AS_role?.maximumAllowed!}
                minAge={AS_role?.minimumAge}
                maxAge={AS_role?.maximumAge}
                cost={associateCosts[AS_role?.roleType!]}
                inRenewal={inRenewal!}
                disabled={ASmaxHasBeenReached}
              />
            </Box>
          </Card>
        ) : (
          <></>
        )}
      </Stack>
      <RoleTypeDisclaimer />
      <Button disabled={submitButtonDisabled} id="roleTypeFormAddButton" type="submit" label="Add member" fullWidth />
    </Form>
  );
};
